import { render, staticRenderFns } from "./email.vue?vue&type=template&id=6b2d15c0&scoped=true"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"
import style0 from "./email.vue?vue&type=style&index=0&id=6b2d15c0&prod&lang=less"
import style1 from "./email.vue?vue&type=style&index=1&id=6b2d15c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2d15c0",
  null
  
)

export default component.exports